import axios from 'utils/axios';

const API_URL = 'auth';

// Use axios baseURL; call endpoints relative to it so runtime base URL works.
export const getUserByToken = async () => {
  return await axios.get(API_URL + '/token');
};

export const loginService = async (reqData: object) => {
  return await axios.post(API_URL + '/login', reqData);
};

export const registerWebPushToken = async (body: { webFcmToken: string }) => {
  return await axios.put(API_URL + '/web-push-token', body);
};

export const logoutService = async (reqData: object) => {
  return await axios.post(API_URL + '/logout', reqData);
};

export const forgotPasswordService = (reqData: object) => {
  return axios.post(API_URL + '/forgotPassword', reqData);
};

export const verifyTokenService = (reqData: object) => {
  return axios.put(API_URL + '/verifyToken', reqData);
};

export const verifyTwoFactorAuthenticationOtp = (reqData: object) => {
  return axios.post(API_URL + '/two-factor-authentication', reqData);
};

export const resendTwoFactorAuthenticationOtp = (reqData: object) => {
  return axios.post(API_URL + '/resend-otp', reqData);
};

export const verifyUpdateAuthMethod = (reqData: object) => {
  return axios.post(API_URL + '/verifyUpdateAuthMethod', reqData);
};

export const enableDisableTwoFactorAuthentication = (reqData: object) => {
  return axios.patch(API_URL + '/update-two-factor-authentication', reqData);
};

export const generateAuthAppQR = () => {
  return axios.get(API_URL + '/generateAuthAppQR');
};

export const setDeviceExamReady = (reqData: object) => {
  return axios.post(API_URL + '/verifyStoreDevice', reqData);
};

export const resetPasswordService = (reqData: object) => {
  return axios.put(API_URL + '/resetPassword', reqData);
};
